import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { axiosInstance } from '../api/axiosInstance';

export function useAuth0Interceptor() {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      const interceptor = axiosInstance.interceptors.request.use(async (config) => {
        try {
          const token = await getAccessTokenSilently();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        } catch (error) {
          console.error('Error getting access token:', error);
          throw error;
        }
        return config;
      });
      return () => {
        axiosInstance.interceptors.request.eject(interceptor);
      };
    }
  }, [isLoading, isAuthenticated, getAccessTokenSilently]);
}
